import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './axios/http.js'
import { getToken } from '@/axios/utils.js'
import dataV from '@jiaminghi/data-view'
import 'echarts'
import ECharts from 'vue-echarts'
import * as echarts from 'echarts'
import china from '@/views/datav/assets/china.json' // 导入china包
import htmlToPdf from '@/axios/htmlToPdf'
import VueKonva from 'vue-konva'
import draggable from './directives/draggable'

echarts.registerMap('china', china)
Vue.prototype.$echarts = echarts
Vue.component('v-chart', ECharts)
Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$getToken = getToken()
Vue.use(ElementUI)
Vue.use(dataV)
Vue.use(htmlToPdf)
// 全局注册 VueKonva 组件
Vue.use(VueKonva)
// 格式化时间
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  // 如果value是个数字，就认为它是个UNIX时间戳
  const date = new Date(value * 1000) // 将时间戳转换为毫秒
  // 使用toLocaleDateString或者其他你需要的日期格式化方法
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
})
Vue.prototype.$frontVersion = 'v1.2.49'
Vue.directive('draggable', draggable)
// Vue.config.devtools = true
// console.log('Vue.ECharts', ECharts)
// console.log('Vue.prototype==', Vue.prototype)
console.log('process.env', process.env)
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
